export const MARKETING_ORIGIN = 'https://menuvera.online';
export const DASHBOARD_ORIGIN = 'https://dashboard.menuvera.online';

const MARKETING_HOSTS = new Set(['menuvera.online', 'www.menuvera.online']);
const DASHBOARD_HOST = 'dashboard.menuvera.online';

export function isDashboardHost(
  hostname = typeof window === 'undefined' ? '' : window.location.hostname,
): boolean {
  return hostname === DASHBOARD_HOST;
}

export function isMarketingHost(
  hostname = typeof window === 'undefined' ? '' : window.location.hostname,
): boolean {
  return MARKETING_HOSTS.has(hostname);
}

/** Auth/app links from the marketing site jump to the dashboard origin. */
export function dashboardHref(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  if (isMarketingHost()) return `${DASHBOARD_ORIGIN}${normalized}`;
  return normalized;
}

/** Brand/home links from the dashboard jump back to the marketing origin. */
export function marketingHref(path = '/'): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  if (isDashboardHost()) return `${MARKETING_ORIGIN}${normalized}`;
  return normalized;
}
